import { Box, Popover, Stack, Text, useMantineTheme } from '@mantine/core';
import { IconEye } from '@tabler/icons-react';
import { useState } from 'react';
import type { Assignee } from 'shared/hooks/use-load-tasks';

import { TaskBadge } from './TaskBadge';

export type CcAssignee = Pick<Assignee, 'id' | 'first_name' | 'last_name'>;

type CcAssigneesBadgeProps = {
  assignees: CcAssignee[];
};

const fullName = (assignee: CcAssignee) => `${assignee.first_name} ${assignee.last_name}`;

export const CcAssigneesBadge = ({ assignees }: CcAssigneesBadgeProps) => {
  const theme = useMantineTheme();
  const [isOpened, setIsOpened] = useState(false);

  if (assignees.length === 0) return null;

  const label = assignees.length === 1 ? fullName(assignees[0]) : `+${assignees.length}`;

  return (
    <Popover opened={isOpened} onChange={setIsOpened} position="bottom-start" withinPortal>
      <Popover.Target>
        <Box>
          <TaskBadge
            aria-label="CC"
            icon={<IconEye size={18} stroke={1.5} color={theme.colors.purple[5]} />}
            onClick={() => setIsOpened(o => !o)}
          >
            <Text size="sm">{label}</Text>
          </TaskBadge>
        </Box>
      </Popover.Target>
      <Popover.Dropdown p="xs" onClick={e => e.stopPropagation()}>
        <Stack gap={2}>
          {assignees.map(assignee => (
            <Text key={assignee.id} size="sm">
              {fullName(assignee)}
            </Text>
          ))}
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};
